import { CSSProperties, ReactNode } from 'react';

import styles from './buttonGroup.module.css';

export type ButtonGroupProps = {
	children: ReactNode | ReactNode[];
	cols?: number;
};

export const ButtonGroup = ({ children, cols = 2 }: ButtonGroupProps) => {
	return (
		<div
			className={styles.root}
			style={{ '--button-group-cols': cols } as CSSProperties}
		>
			{children}
		</div>
	);
};
